module.exports = __webpack_public_path__ + "static/media/aprovado.5b2599d5.png";